// extracted by mini-css-extract-plugin
module.exports = {"section":"pricing_section__PUFYQ"};